var INPUTS_SELECTOR = 'input[type="text"], input[type="email"], input[type="password"], input[type="tel"], textarea';

checkInputs();
function checkInputs(context) {
    $(context || document).find(INPUTS_SELECTOR).each(function () {
        $(this).closest('.form-group').toggleClass('focused', !!$(this).val());
    });
    $('#fullName').closest('.form-group').toggleClass('focused', !!$('#fullName').val());
    $('#name').closest('.form-group').toggleClass('focused', !!$('#fullName').val());
}

// Delegováno na document, takže to funguje i pro obsah doplněný později (např. colorbox) -
// není potřeba se znovu vázat na nové inputy.
$(document).on('click focus', INPUTS_SELECTOR, function () {
    $(this).closest('.form-group').addClass('focused');
});

$(document).on('blur', INPUTS_SELECTOR, function () {
    $(this).closest('.form-group').toggleClass('focused', !!$(this).val());
});

// Shoptet nemá vlastní event pro dokončení načtení obsahu colorboxu,
// ale to zajišťuje colorbox sám - cbox_complete se spustí až je obsah v DOM a vykreslený.
$(document).on('cbox_complete', function () {
    checkInputs('#colorbox');
});

